export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:beforeMount', async () => {
    const route = useRoute();
    const config = useConfig();

    if (config.value.public.lemonwayEnv !== 'production' && route.query.msw === 'true') {
      const { worker } = await import('~/mocks/worker');
      await worker.start({
        onUnhandledRequest: 'bypass'
      });
    }
  });
});
